import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "8", height: "8", x: "3", y: "3", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 11v4a2 2 0 0 0 2 2h4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "8", height: "8", x: "13", y: "13", rx: "2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Workflow";
const Workflow = memo(themed(Icon));
export {
  Workflow
};
//# sourceMappingURL=workflow.js.map
